module.exports = __webpack_public_path__ + "static/media/ndsc_id_cover.16c9d003.jpg";